import { render, staticRenderFns } from "./UserDepartments.vue?vue&type=template&id=2867e043&scoped=true&"
import script from "./UserDepartments.vue?vue&type=script&lang=ts&setup=true&"
export * from "./UserDepartments.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./UserDepartments.vue?vue&type=style&index=0&id=2867e043&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867e043",
  null
  
)

export default component.exports